<template>
    <div class="app-error inline-message is--error" role="alert">
        {{ message }}
        <ul v-for="(data, key) in errors" :key="`error-${key}`">
            <li v-for="(message, index) in data" :key="`error-${key}-${index}`">
                {{ message }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: String
        },
        errors: {
            type: Object,
            default: () => ({ })
        }
    }
}
</script>
